import React from "react";
import logoImage from "../assets/Transparent-LogoZugeschnitten.png";


const SpacerCTA = () => {
  return (
    <section className="spacercta-wrapper">
      <div className="spacercta-bar"></div>

      <div className="spacercta-card">
        <div className="spacercta-left">
          <h3 className="spacercta-text">
            Projekte starten. Lösungen liefern.
          </h3>
          <button
            className="btn"
            onClick={() =>
              document.getElementById("contact")?.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <div>Kontaktieren sie uns</div>
          </button>
        </div>
        <div className="spacercta-right">
          <img src={logoImage} alt="Logo" className="spacercta-logo" />
        </div>
      </div>
    </section>
  );
};

export default SpacerCTA;
